module.exports = __webpack_public_path__ + "static/media/bootcamp-time-allocation.22759b2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bootcamp-time-allocation.png
// module id = 997
// module chunks = 0